export const TASK_TYPE_ENUM = {
  Mapping: 'Mapping',
  CorridorMapping: 'CorridorMapping',
  Spraying: 'Spraying',
  Spreading: 'Spreading',
};
